<div class="gov-card">
  <div class="gov-card__header">
    {{ edit ? 'Edycja decyzji' : 'Dodanie deyzji' }}
  </div>
  <div class="gov-card__body">
    <form *ngIf="form as form" novalidate autocomplete="off" [formGroup]="form">
      <div class="row">
        <div class='col-md-4'>
          <div class='form-group' *ngIf='"decisionNumber" as controlName'>
            <label [for]='controlName'>
              Numer decyzji lokalizacyjnej *
            </label>
            <input
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'
              placeholder='Wpisz tu numer decyzji lokalizacyjnej'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
        <div class='col-md-4'>
          <div class='form-group' *ngIf='"decisionDate" as controlName'>
            <label [for]='controlName'>
              Data wydania decyzji lokalizacyjnej *
            </label>
            <app-date-picker [id]='controlName' [formControlName]='controlName'>
            </app-date-picker>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      </div>
      <div class="form-actions">
        @if (showCancel) {
          <button type="button" class="btn btn-secondary" (click)="onCancel()">
            <i class="fa fa-ban" aria-hidden="true"></i>Anuluj
          </button>
        }
        <button type="button" class="btn btn-secondary" (click)="onSubmit()">
          @if (!edit) {
            <i class="fa fa-plus" aria-hidden="true"></i>Dołącz do wniosku
          } @else {
            <i class="fa fa-save"></i>Zaktualizuj dane
          }
        </button>
      </div>
    </form>
  </div>
</div>
